import { Suspense } from "react";
import { Route, Routes } from "react-router";
import { DashboardRouter } from "./router";
import { PageContainer } from "etl/design-system/organisms/PageContainer";
import { FallBackSpinner } from "etl/design-system/molecules/FallBackSpinner";

export const EtlDashboard = () => {
	return (
		<Suspense fallback={< FallBackSpinner />}>
			<PageContainer>
				<Routes>
					{DashboardRouter.map((route) =>
						<Route key={route.path} path={route.path} element={route.component} />
					)}
				</Routes>
			</PageContainer>
		</Suspense>
	)
};
